import { tryParseJSON } from '../lib/tryParseJSON/tryParseJSON';
import { findSettingsChild } from './findSettingsChild';
import { type SettingsHierarchyNode } from './types';

export type GetSettingValueMode = 'branch' | 'leaf';

const normalizeSettingPath = (path: string) => (path.startsWith('/') ? path : `/${path}`);

/*
 * Функция для получения значения узла настройки
 * @param settings - иерархия настроек
 * @param branchPath - ветка настроек, в которой осуществляется поиск
 * @param leafPath - путь до настройки
 * @param mode - `branch` (по умолчанию): искать лист в children;
 *   `leaf`: корень иерархии и есть нужный лист (точечный запрос path)
 */
export function getSettingValue<TLeafPath extends string, TResponses extends Record<TLeafPath, unknown>>(
    settings: SettingsHierarchyNode | undefined,
    branchPath: string,
    leafPath: TLeafPath,
    mode: GetSettingValueMode = 'branch'
): TResponses[TLeafPath] | undefined {
    if (!settings) {
        return undefined;
    }

    if (mode === 'leaf') {
        const normalizedLeafPath = normalizeSettingPath(leafPath);

        if (settings.setting?.path === normalizedLeafPath && settings.setting.value) {
            return tryParseJSON<TResponses[TLeafPath]>(settings.setting.value);
        }

        return undefined;
    }

    const leafPathArray = leafPath.replace(`${branchPath}/`, '/').split('/').filter(Boolean);
    const valueLeaf = findSettingsChild(settings, leafPathArray, leafPath);

    if (valueLeaf?.setting?.value) {
        return tryParseJSON<TResponses[TLeafPath]>(valueLeaf.setting.value);
    }

    return undefined;
}
